class CatalogCategories {
	constructor(container, option = {}) {
		this.container = container;
		if (!this.container) return;
		this.list = this.container.querySelector('[data-catalog-categories-container] .list');
		this.listItems = this.container.querySelectorAll('[data-catalog-categories]');
		this.content = this.container.querySelector('[data-catalog-categories-content]');
		this.contentWidth = this.content.clientWidth;
		this.slider = document.querySelector('.slider');
		this.hamburger = document.querySelector('[data-toggle=categories]');
		this.openCategories = false;

		[...this.listItems]
			.filter(el => {
				let children = el.querySelector('.vg-sidebar-main__links');
				return children.children.length
			})
			.forEach((element) => {
				this.onHover(element);
			});
	}

	removeClass(element, $class) {
		element.classList.remove($class);
	}

	addClass(element, $class) {
		element.classList.add($class);
	}

	onHover(element) {
		element.addEventListener('mouseover', () => {
			this.addClass(element, 'show');
			if(this.slider) {
				this.slider.style.transform = `translateX(${this.contentWidth}px)`;
			}
			if(this.list) {
				this.addClass(this.list, 'visible')
			}
		});

		element.addEventListener('mouseout', () => {
			this.removeClass(element, 'show');
			if(this.slider) {
				this.slider.style.transform = ``;
			}
			if(this.list) {
				this.removeClass(this.list, 'visible')
			}
		});
	}

	showCategories() {
		if(!this.hamburger) return;
		this.header = document.querySelector('.header .header-bottom');
		if(!this.header) return;

		this.hamburger.addEventListener('click', (e) => {
			e.preventDefault();
			if(this.header.classList.contains('show-categories')) {
				this.header.classList.remove('show-categories');
			} else {
				this.header.classList.add('show-categories');
			}

			this.closeCategories();
		});
	}

	closeCategories() {
		document.onclick = (e) => {
			if(!e.target.closest('.catalog-categories') && !e.target.closest('.link-catalog')) {
				this.header.classList.remove('show-categories');
				document.onclick = null;
			}
		};
	}
}

export {
	CatalogCategories
};

